export default __webpack_public_path__ + "static/media/star.b98637c5.svg";